
import { Vue, Component, Mixins, Emit } from 'vue-property-decorator';
import LayoutCol1 from '@/components/layout/LayoutCol1.vue';
import HomeCampaignlistItem from '@/components/home/HomeCampaignlist/HomeCampaignlistItem.vue';
import $ from 'jquery';
import VueRouter, {Route} from 'vue-router';
import store from '@/store';
import NaviArchive from '@/components/navi/NaviArchive.vue';
import { fetchPosts } from '@/services/userService';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
  'beforeDestroy',
]);

const breadcrumbPath = [
  {
    label: 'ホーム',
    url: '/',
  },
  {
    label: 'ニュース',
    url: '/news/',
  },
];

const ITEM_MAX_LENGTH = 10;
const CATEGORY = 'info';

async function getDatas(to: Route) {
  const offset: number = (Number(to.query.p) - 1) * ITEM_MAX_LENGTH;
  const params = {
    cat: CATEGORY,
    offset,
    length: ITEM_MAX_LENGTH,
  };
  const res = await fetchPosts(params);
  return res;
}

@Component({
  components: {
    LayoutCol1,
    HomeCampaignlistItem,
    NaviArchive,
  },
})
export default class CampaignIndex extends Vue {
  private name = 'CampaignIndex';
  private newentriesLabel = '新着記事';
  private title1 = 'CAMPAIGN';
  private title2 = 'SPECIAL CONTENTS';
  private totaleItems: number = 0;
  private length: number = ITEM_MAX_LENGTH;
  private list: PostData[] = [];
  private loading: boolean = true;

  get pageNum(): number {
    return Number(this.$route.query.p);
  }

  private async beforeRouteEnter(to: Route, from: Route, next: any) {
    const res = await getDatas(to);
    store.commit('breadcrumb/setPath', breadcrumbPath);
    next((vm: {
      totaleItems: number,
      list: any,
      loading: boolean,
    }) => {
      vm.totaleItems = Number(res.hits);
      vm.list = res.datas;
      vm.loading = false;
    });
  }

  private async beforeRouteUpdate(to: Route, from: Route, next: any) {
    this.loading = true;
    const res = await getDatas(to);
    this.totaleItems = Number(res.hits);
    this.list = res.datas;
    this.loading = false;
    next();
  }

  private mounted() {
    this.$store.commit('loaded', true);
  }
}
